import { apiClient } from './api.client';

/**
 * D2 (§11) — read-only compliance audit ledger (admin console). Surfaces privileged actions that
 * previously had no trail: Identity-Review clear/reject, consent grant/withdraw, etc.
 */
export interface ComplianceAuditEventDto {
  id: number;
  actor?: string | null;
  actorRole?: string | null;
  action?: string | null;
  entityType?: string | null;
  entityId?: string | null;
  investorUniqueId?: string | null;
  detail?: string | null;
  ipAddress?: string | null;
  createdAt?: string | null;
}

class AuditService {
  private baseUrl = '/api/admin/audit';

  /** Compliance audit feed, newest first; optional entityType filter (e.g. IdentityRelationship, Consent). */
  async list(entityType?: string): Promise<ComplianceAuditEventDto[]> {
    const url = entityType ? `${this.baseUrl}?entityType=${encodeURIComponent(entityType)}` : this.baseUrl;
    const res = await apiClient.get<ComplianceAuditEventDto[]>(url);
    return res.data ?? [];
  }
}

export const auditService = new AuditService();
